"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { Problem } from "./problem";
import { Solution } from "./solution";
import { WhatDemoCovers } from "./what-demo-covers";
import { DemoForm } from "./demo-form";
import { WhatToExpect } from "./what-to-expect";
import { Walkthrough } from "./walkthrough";
import { KeyMetrics } from "./key-metrics";
import { PlatformPreview } from "./platform-preview";
import { WhoAttend } from "./who-attend";
import { Confidentiality } from "./confidentiality";
import { WhyUs } from "./why-us";
import { HowItWorks } from "./how-it-works";
import { DemoFaq } from "./faq";
import { Paa } from "./paa";
import { DemoCta } from "./cta";

export function DemoPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-crimson">
        <ExecutiveSummary />
      </div>
      <Problem />
      <div className="bg-aurora-emerald">
        <Solution />
      </div>
      <WhatDemoCovers />
      <div className="bg-aurora-amber">
        <DemoForm />
      </div>
      <WhatToExpect />
      <div className="bg-aurora-purple">
        <Walkthrough />
      </div>
      <KeyMetrics />
      <div className="bg-aurora-cyan">
        <PlatformPreview />
      </div>
      <WhoAttend />
      <div className="bg-aurora-emerald">
        <Confidentiality />
      </div>
      <WhyUs />
      <div className="bg-aurora-amber">
        <HowItWorks />
      </div>
      <DemoFaq />
      <div className="bg-aurora-purple">
        <Paa />
      </div>
      <DemoCta />
    </>
  );
}
